import React, { useEffect, useState, createElement, Component } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, Star, Clock, ShieldCheck, ChevronDown, ChevronUp, ChevronLeft, ChevronRight, Gift, Zap, Crown } from 'lucide-react';
// Pixel de Meta Events Manager para esta página.
const META_PIXEL_IDS = ['1285677670304642'];
function useMetaPixels(pixelIds: string[]) {
  useEffect(() => {
    if (typeof window === 'undefined' || pixelIds.length === 0) return;
    try {
      const w = window as any;
      const d = document;
      // Snippet oficial de Meta Pixel (base code).
      if (!w.fbq) {
        /* eslint-disable */
        ;
        (function (f: any, b: Document, e: string, v: string) {
          if (f.fbq) return;
          const n: any = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          const t = b.createElement(e) as HTMLScriptElement;
          t.async = true;
          t.src = v;
          const s = b.getElementsByTagName(e)[0];
          s.parentNode?.insertBefore(t, s);
        })(w, d, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        /* eslint-enable */
      }
      pixelIds.forEach(pixelId => w.fbq('init', pixelId));
      w.fbq('track', 'PageView');
      console.info('[Meta Pixel] init + PageView disparados. IDs:', pixelIds);

      // Fallback <noscript> para ambos píxeles.
      if (!d.getElementById('mp-fb-pixel-noscript')) {
        const noscript = d.createElement('noscript');
        noscript.id = 'mp-fb-pixel-noscript';
        pixelIds.forEach(pixelId => {
          const img = d.createElement('img');
          img.height = 1;
          img.width = 1;
          img.style.display = 'none';
          img.alt = '';
          img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
          noscript.appendChild(img);
        });
        d.body.appendChild(noscript);
      }
    } catch (err) {
      // El pixel nunca debe romper el render de la página.
      console.warn('Meta Pixel no se pudo inicializar:', err);
    }
  }, [pixelIds]);
}
export function App() {
  useMetaPixels(META_PIXEL_IDS);
  return <div className="min-h-screen bg-[#FFFDF9] text-[#2D1816] font-['Inter',sans-serif] selection:bg-pink-200 selection:text-pink-900" data-id="element-0" data-mp="86cnpbiddjmt">
      <HeroSection data-id="element-1" data-mp="3bmbgfvo82ln1" />
      <PainSection data-id="element-2" data-mp="3bmtg72a3fhzp" />
      <SolutionSection data-id="element-3" data-mp="3bnmgpliglb9e" />
      <TomosSection data-id="element-4" data-mp="3bo4l55f9yvse" />
      <PeekInsideSection data-id="element-5" data-mp="3qb7j1d7if6g9" />
      <BonosSection data-id="element-6" data-mp="3qbpl4qgusew3" />
      <ChangesSection data-id="element-7" data-mp="3qbzg6sgr9c8n" />
      <OfferSection data-id="element-8" data-mp="3qcin7e4vag7w" />
      <GuaranteeSection data-id="element-9" data-mp="3qd0owqaatmn7" />
      <TestimonialsSection data-id="element-10" data-mp="3ljxukfxp695y" />
      <FAQSection data-id="element-11" data-mp="3ljpk0up1rfxx" />
      <FinalCloseSection data-id="element-12" data-mp="3lj6bg4lae3wk" />
      <Footer data-id="element-13" data-mp="2xuwsdafgju94" />
    </div>;
}
const CHECKOUT_URL = 'https://recursohub.com/cart/45942837608550:1';
const COMBO_CHECKOUT_URL = 'https://recursohub.com/cart/45942864609382:1';
// Dispara un evento del Meta Pixel de forma segura (nunca rompe el render).
function trackFbEvent(event: string, params?: Record<string, unknown>) {
  try {
    const w = window as any;
    if (w && typeof w.fbq === 'function') {
      w.fbq('track', event, params);
    }
  } catch (err) {
    console.warn('No se pudo registrar el evento del pixel:', err);
  }
}
const CTAButton = ({
  text,
  subtext,
  href = CHECKOUT_URL,
  variant = 'primary',
  contentName = 'Mega Pack Emprende Minidonas 360',
  value = 14990
}: {
  text: string;
  subtext?: string;
  href?: string;
  variant?: 'primary' | 'combo';
  contentName?: string;
  value?: number;
}) => {
  const isCombo = variant === 'combo';
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
    content_name: contentName,
    currency: 'ARS',
    value
  })} className={isCombo ? 'group relative inline-flex flex-col items-center justify-center w-full px-6 py-3.5 text-base md:text-lg font-black text-[#2D1816] transition-all duration-200 bg-amber-400 border border-amber-300 rounded-lg hover:bg-amber-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.5)] hover:shadow-[0_0_30px_rgba(245,158,11,0.7)] hover:-translate-y-0.5' : 'group relative inline-flex flex-col items-center justify-center w-full sm:w-auto px-6 py-3 text-base font-bold text-white transition-all duration-200 bg-[#E85D75] border border-transparent rounded-lg hover:bg-[#D64A62] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E85D75] shadow-[0_0_16px_rgba(232,93,117,0.35)] hover:shadow-[0_0_24px_rgba(232,93,117,0.5)] hover:-translate-y-0.5'} data-id="element-14" data-mp="1i5nj1bfbbdk5">
      <span className="flex items-center gap-2 font-['Outfit',sans-serif] tracking-wide" data-id="element-15" data-mp="zzoei57fgcqe">
        {text}
      </span>
      {subtext && <span className={isCombo ? 'mt-0.5 text-xs font-semibold text-[#5C3D3A]' : 'mt-0.5 text-xs font-medium text-pink-100'} data-id="element-16" data-mp="3kokndjgzxd20">
          {subtext}
        </span>}
    </a>;
};
function HeroSection() {
  return <section className="relative pt-8 pb-16 md:pt-12 md:pb-24 px-4 overflow-hidden" data-id="element-17" data-mp="1w5812yygqqt2">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-pink-100/60 via-[#FFFDF9] to-[#FFFDF9]" data-id="element-18" data-mp="205ihz6nsn1mp"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-19" data-mp="253sfhnwzqebh">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-pink-200 bg-pink-50 text-[#E85D75] text-sm font-bold tracking-wide mb-8 uppercase shadow-sm" data-id="element-20" data-mp="29wv8nuxuvlr5">
          <span className="w-2 h-2 rounded-full bg-[#E85D75] animate-pulse" data-id="element-21" data-mp="2jt80sodr5rjs"></span>
          SISTEMA DE NEGOCIO COMPROBADO
        </div>

        <h1 className="md:text-6xl lg:text-7xl font-black font-['Outfit',sans-serif] tracking-tight mb-8 text-[#2D1816] text-[30px]" data-id="element-22" data-mp="2nwe4ppde76n3">
          <span className="text-[#E85D75]" data-id="element-23" data-mp="thle64rd9620">TOMÁ EL CONTROL</span>   DE TU ECONOMÍA HOY MISMO CON EL{' '}
          <span className="text-[#E85D75]" data-id="element-24" data-mp="ygepprn3emzj">NEGOCIO DE MINIDONAS</span> MÁS
          VERSÁTIL DE LATINOAMÉRICA.    
        </h1>

        <p className="md:text-2xl text-[#5C3D3A] mb-10 max-w-3xl mx-auto font-medium text-[18px]" data-id="element-25" data-mp="21slsty9610th">
          Accedé al método exacto para vender minidonas profesionales desde tu
          casa, eliminando la frustración de las recetas que fallan y logrando
          tus primeros clientes en menos de 7 días, sin necesidad de inversión
          inicial en equipos caros.
        </p>

        <div className="mb-10 max-w-4xl mx-auto" data-id="element-26" data-mp="2kpwtnnag42b1">
          <img src="https://cdn.magicpatterns.com/uploads/o9m4HrEpD6yvwXYFsRXQug/ChatGPT_Image_9_ago_2026,_10_16_13_a.m..png" alt="Mega Pack Emprende Minidonas 360 — 6 tomos completos más 3 bonos exclusivos, 9 productos en una colección" className="w-full h-auto rounded-2xl shadow-2xl border border-pink-100" data-id="element-27" data-mp="2kobvlnoxa18f" />
        </div>

        <div className="mb-10" data-id="element-28" data-mp="33gxp41ccxfpu">
          <p className="text-lg font-bold text-[#E85D75] mb-4 font-['Outfit',sans-serif]" data-id="element-29" data-mp="33hzb30uwvmmc">
            Mega Pack Emprende Minidonas 360 — 6 Tomos + 3 Bonos
          </p>
          <a href="#oferta" className="group relative inline-flex flex-col items-center justify-center w-full sm:w-auto px-6 py-3 text-base font-bold text-white transition-all duration-200 bg-[#E85D75] border border-transparent rounded-lg hover:bg-[#D64A62] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E85D75] shadow-[0_0_16px_rgba(232,93,117,0.35)] hover:shadow-[0_0_24px_rgba(232,93,117,0.5)] hover:-translate-y-0.5" data-id="element-30" data-mp="3i3wd1mc09rzt">
            <span className="flex items-center gap-2 font-['Outfit',sans-serif] tracking-wide" data-id="element-31" data-mp="2zcdbljxmqlzw">
              ✅ SÍ, QUIERO MI PACK AHORA
            </span>
          </a>
        </div>

        <div className="flex flex-col items-center justify-center gap-3 text-sm text-[#5C3D3A] font-medium" data-id="element-32" data-mp="2pfqth2wou91k">
          <div className="flex items-center gap-1 text-amber-400" data-id="element-33" data-mp="2uetxck0xm97y">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-34" data-mp="2gfc6lz42slvy" data-mpi={i} />)}
          </div>
          <p data-id="element-35" data-mp="2kge3waefmnva">
            4.9/5 — Reseñas verificadas | Con la confianza de emprendedoras en
            toda Latinoamérica
          </p>
          <p className="flex items-center gap-1" data-id="element-36" data-mp="30uvh6u29pmnp">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-37" data-mp="2vwk84ljsrg6j" /> Garantía de
            devolución de 7 días: riesgo cero.
          </p>
        </div>
      </div>
    </section>;
}
function PainSection() {
  const pains = [{
    emoji: '😰',
    title: 'Recetas sueltas que no funcionan',
    desc: 'Buscás en YouTube, en grupos de Facebook, en Pinterest... encontrás mil recetas distintas y ninguna te da el resultado que ves en las fotos.'
  }, {
    emoji: '🤷‍♀️',
    title: 'No sabés por dónde empezar',
    desc: '¿Primero las recetas? ¿Primero el packaging? ¿Primero Instagram? La falta de orden te paraliza antes de empezar.'
  }, {
    emoji: '📱',
    title: 'Sobrecarga de información contradictoria',
    desc: 'Cada influencer enseña algo diferente. Una dice una cosa, otra dice lo contrario. No sabés en qué sistema confiar ni qué funciona de verdad.'
  }, {
    emoji: '💸',
    title: 'Miedo a invertir y no recuperarlo',
    desc: 'Ya gastaste en ingredientes, en moldes, en cursos que prometían mucho y entregaron poco. No querés cometer el mismo error otra vez.'
  }];
  return <section className="py-20 px-4 bg-[#FFF5EB]" data-id="element-38" data-mp="ipks564a46yw">
      <div className="max-w-5xl mx-auto" data-id="element-39" data-mp="iqvur2lzn8of">
        <div className="text-center mb-16" data-id="element-40" data-mp="nonntzydd0u7">
          <h2 className="text-3xl md:text-5xl font-black mb-4 text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-41" data-mp="nnm9nmm23y89">
            ¿TE SUENA FAMILIAR?
          </h2>
          <p className="text-xl text-[#5C3D3A] font-medium" data-id="element-42" data-mp="3r5dzovgmu83t">
            Te encanta la idea de emprender con minidonas, pero algo siempre te
            frena.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-43" data-mp="3w2nwiw6cpm1o">
          {pains.map((pain, idx) => <div key={idx} className="bg-white p-8 rounded-2xl border border-amber-100 hover:border-pink-300 hover:shadow-lg transition-all duration-300" data-id="element-44" data-mp="4r4cuqscp855" data-mpi={idx}>
              <div className="mb-4 bg-pink-50 w-16 h-16 rounded-full flex items-center justify-center text-3xl" data-id="element-45" data-mp="38ed5ekqgj0ql">
                <span role="img" aria-label={pain.title} data-id="element-46" data-mp="2f63lbu191meh">
                  {pain.emoji}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-47" data-mp="2k4di292mgv27">
                {pain.title}
              </h3>
              <p className="text-[#5C3D3A] leading-relaxed" data-id="element-48" data-mp="2u4xmfklfufon">{pain.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function SolutionSection() {
  return <section className="py-20 px-4 bg-[#FFFDF9]" data-id="element-49" data-mp="1wej75x1v5gkl">
      <div className="max-w-4xl mx-auto text-center" data-id="element-50" data-mp="21exbp549a8dv">
        <h2 className="text-3xl md:text-5xl font-black mb-6 text-[#E85D75] font-['Outfit',sans-serif]" data-id="element-51" data-mp="21ddw7gqfc1d5">
          LA SOLUCIÓN QUE ESTABAS ESPERANDO
        </h2>
        <h3 className="text-2xl md:text-3xl font-bold mb-8 text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-52" data-mp="2b6bk62e6qij5">
          UN SISTEMA COMPLETO DE 6 TOMOS PARA EMPRENDER CON MINIDONAS
        </h3>
        <p className="text-xl text-[#5C3D3A] mb-10 font-medium" data-id="element-53" data-mp="1io7cbqdw93pr">
          Diseñado específicamente para emprendedoras latinoamericanas que
          quieren resultados reales desde el primer día.
        </p>

        <div className="mb-10 rounded-2xl overflow-hidden shadow-xl border border-pink-100" data-id="element-54" data-mp="3rz8aujc7ez6w">
          <img src="https://cdn.magicpatterns.com/uploads/rzNQoAkqWcJW8WrroFxxhX/ChatGPT_Image_7_jul_2026,_12_47_04_a.m..png" alt="Los 6 tomos del Mega Pack Emprende Minidonas 360: un sistema completo para crear, vender y escalar tu negocio de minidonas" className="w-full h-auto block" data-id="element-55" data-mp="3mxizf2l2kjia" />
        </div>

        <div className="bg-gradient-to-b from-[#4A2B29] to-[#3E201D] p-8 md:p-12 rounded-3xl border border-[#5C3D3A] shadow-2xl text-left relative overflow-hidden" data-id="element-56" data-mp="3894oe4di1oqn">
          <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-57" data-mp="2z9roa2b9mcil"></div>

          <p className="text-lg text-pink-50 mb-6 leading-relaxed relative z-10" data-id="element-58" data-mp="2u93mclli0b9l">
            El{' '}
            <strong className="text-white font-bold" data-id="element-59" data-mp="2pc3hge0dxek2">
              Mega Pack Emprende Minidonas 360
            </strong>{' '}
            es mucho más que un recetario.
          </p>
          <p className="text-lg text-pink-50 mb-8 leading-relaxed relative z-10" data-id="element-60" data-mp="2kn2gzearuv1n">
            Es un sistema operativo completo para tu negocio de minidonas que
            incluye recetas maestras, técnicas de decoración profesional,
            minidonas saladas y fritas, branding con celular, gestión de precios
            y estrategia de ventas.
          </p>

          <ul className="space-y-4 relative z-10" data-id="element-61" data-mp="2yga711j7fih8">
            {['Todo organizado.', 'Todo paso a paso.', 'Todo listo para aplicar hoy.'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-xl font-bold text-white font-['Outfit',sans-serif]" data-id="element-62" data-mp="2pkkqb5spbca6" data-mpi={idx}>
                <CheckCircle2 className="w-6 h-6 text-pink-400 flex-shrink-0" data-id="element-63" data-mp="2tlo65sar18be" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}
function TomosSection() {
  const tomos = [{
    num: 'TOMO 1',
    title: 'EL ADN DE LA MASA & SABORES ESTRELLA',
    desc: 'La masa base perfecta más 8 sabores estrella: Red Velvet, Chocolate, Limón, Oreo, Banana, Arándano, Naranja y Zanahoria.',
    highlight: 'El más buscado'
  }, {
    num: 'TOMO 2',
    title: 'MASTER DE GLASEADOS, COLORES Y TOPPINGS',
    desc: 'Técnicas de glaseado profesional: inmersión, drip, efecto mármol, ganache y decoración temática para cada ocasión.'
  }, {
    num: 'TOMO 3',
    title: 'BRUNCH GOURMET — MINIDONAS SALADAS',
    desc: 'Las 3 masas maestras saladas más 8 recetas completas para conquistar el mercado de brunchs y eventos.',
    highlight: 'Nuevo nicho con poca competencia'
  }, {
    num: 'TOMO 4',
    title: 'FRITAS & RELLENAS — SABOR TRADICIONAL',
    desc: 'Masa levada para fritura perfecta más 6 rellenos clásicos: dulce de leche, Nutella, crema pastelera y más.'
  }, {
    num: 'TOMO 5',
    title: 'FOTO & BRANDING CON CELULAR',
    desc: 'El sistema completo para fotografiar tus minidonas y construir una marca irresistible usando solo tu celular.'
  }, {
    num: 'TOMO 6',
    title: 'TU NEGOCIO EN DÓLARES — GESTIÓN GLOBAL',
    desc: 'Costos, precios, canales de venta, WhatsApp Business, redes sociales y estrategia para escalar en Latinoamérica.'
  }];
  return <section className="py-20 px-4 bg-[#FFF5EB]" data-id="element-64" data-mp="qm6pe9pwfyxy">
      <div className="max-w-6xl mx-auto" data-id="element-65" data-mp="vn46sk334oye">
        <h2 className="text-3xl md:text-5xl font-black mb-16 text-center text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-66" data-mp="vo5tjltgqzvy">
          EL SISTEMA COMPLETO DE 6 TOMOS
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-67" data-mp="15jqq34frj7yb">
          {tomos.map((tomo, idx) => <div key={idx} className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 group ${tomo.highlight ? 'border-2 border-amber-400 ring-2 ring-amber-400/20 shadow-xl' : 'border border-amber-100 hover:border-pink-300 hover:shadow-xl'}`} data-id="element-68" data-mp="1ab8slwxfpgle" data-mpi={idx}>
              <div className={`p-4 border-b flex items-center justify-between gap-2 ${tomo.highlight ? 'bg-amber-400 border-amber-300' : 'bg-pink-50 border-pink-100'}`} data-id="element-69" data-mp="1jace17k2q832">
                <span className={`font-bold tracking-wider text-sm font-['Outfit',sans-serif] ${tomo.highlight ? 'text-[#2D1816]' : 'text-[#E85D75]'}`} data-id="element-70" data-mp="1ygi3rd91hwtd">
                  {tomo.num}
                </span>
                {tomo.highlight && <span className="flex items-center gap-1 bg-[#2D1816] text-amber-300 text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full font-['Outfit',sans-serif]" data-id="element-71" data-mp="1oiu5idc8676g">
                    <Star className="w-3 h-3 fill-current" data-id="element-72" data-mp="2h7sotds33fdc" />
                    {tomo.highlight}
                  </span>}
              </div>
              <div className="p-6" data-id="element-73" data-mp="27fdcox3gxl0d">
                <h3 className="text-xl font-bold mb-4 text-[#2D1816] group-hover:text-[#E85D75] transition-colors font-['Outfit',sans-serif]" data-id="element-74" data-mp="27ebyijr5oief">
                  {tomo.title}
                </h3>
                <p className="text-[#5C3D3A] leading-relaxed" data-id="element-75" data-mp="2zxqz80jctkk5">{tomo.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BonosSection() {
  const bonos = [{
    title: 'EL MASTER DE TORRES Y TORTAS TEMÁTICAS',
    desc: 'El sistema completo para armar torres de minidonas y tortas temáticas que se venden solas en cumpleaños, baby showers, casamientos y eventos. El producto más fotografiable y cotizado del menú.',
    icon: <Gift className="w-10 h-10 text-pink-300" data-id="element-76" data-mp="ogp1nmrt669v" />,
    image: 'https://cdn.magicpatterns.com/uploads/sj816P7d8GnacaV4JttH7b/ChatGPT_Image_6_jul_2026,_11_18_50_p.m..png'
  }, {
    title: 'EL PLAN "PRIMERA VENTA EN 7 DÍAS"',
    desc: 'Un plan de acción día a día para vender tus primeras minidonas en menos de una semana. Incluye plantillas de mensajes para WhatsApp, textos para Instagram y guía de manejo de objeciones.',
    icon: <Zap className="w-10 h-10 text-amber-300" data-id="element-77" data-mp="5j4fwokcbnth" />,
    image: 'https://cdn.magicpatterns.com/uploads/hiombg6evQUaRAAVCE5E9p/ChatGPT_Image_6_jul_2026,_11_19_04_p.m..png'
  }, {
    title: 'MINIDONAS SANDWICH & RELLENOS EXPLOSIVOS',
    desc: 'El sistema para crear minidonas sandwich con rellenos dulces y salados que detienen el scroll y generan ventas instantáneas. El contenido más viral y compartible de todo el pack.',
    icon: <Star className="w-10 h-10 text-purple-300" data-id="element-78" data-mp="3fd8p2lbur0x5" />,
    image: 'https://cdn.magicpatterns.com/uploads/msvANLhAUaFWQ8TTbGkf82/ChatGPT_Image_6_jul_2026,_11_19_11_p.m..png'
  }];
  return <section className="py-20 px-4 relative overflow-hidden bg-[#4A2B29]" data-id="element-79" data-mp="3pbwvemuh5rl0">
      <div className="absolute inset-0 bg-gradient-to-b from-[#3E201D] to-[#4A2B29]" data-id="element-80" data-mp="6ygux73zlyd4"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-81" data-mp="2yojmmn7le42">
        <h2 className="text-3xl md:text-5xl font-black mb-16 text-center text-pink-300 font-['Outfit',sans-serif]" data-id="element-82" data-mp="309dsb5m2v1e">
          3 BONOS INCLUIDOS — GRATIS CON TU COMPRA DE HOY
        </h2>

        <div className="space-y-6 mb-12" data-id="element-83" data-mp="bwidlqxi3vo2">
          {bonos.map((bono, idx) => <div key={idx} className="flex flex-col md:flex-row gap-6 md:items-center bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-84" data-mp="2ipu9eqe0v806" data-mpi={idx}>
              {bono.image ? <img src={bono.image} alt={bono.title} className="flex-shrink-0 w-full md:w-56 h-auto rounded-xl shadow-lg border border-white/10 object-cover" data-id="element-85" data-mp="1rw0x7rzf6v5g" /> : <div className="flex-shrink-0 bg-white/10 p-4 rounded-xl h-fit shadow-inner" data-id="element-86" data-mp="21mlpyysex5gg">
                  {bono.icon}
                </div>}
              <div data-id="element-87" data-mp="26kdjtycmb1na">
                <div className="text-sm font-bold text-pink-300 mb-2 tracking-wider uppercase font-['Outfit',sans-serif]" data-id="element-88" data-mp="26kx0lbqj7jzq">
                  BONO {idx + 1}
                </div>
                <h3 className="text-2xl font-bold mb-3 text-white font-['Outfit',sans-serif]" data-id="element-89" data-mp="1dxss2ws8cnj7">
                  {bono.title}
                </h3>
                <p className="text-pink-50/80 leading-relaxed text-lg" data-id="element-90" data-mp="1nv78iwe5lcbi">
                  {bono.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-91" data-mp="2uazt1sycyryv">
          <p className="text-xl md:text-2xl font-bold text-white bg-[#E85D75]/20 py-4 px-8 rounded-full inline-block border border-[#E85D75]/30 font-['Outfit',sans-serif]" data-id="element-92" data-mp="2za412g9jqjnm">
            🎁 Los 3 bonos están incluidos GRATIS con tu compra de hoy.
          </p>
        </div>
      </div>
    </section>;
}
function PeekInsideSection() {
  const pages = [{
    src: 'https://cdn.magicpatterns.com/uploads/bkDjaQmEfN3km44BWNaY3z/Captura_de_pantalla_2026-07-07_012056.png',
    caption: 'Recetas con sabores estrella, como Red Velvet'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6ewSREidd2zG8P5AoZZbrg/Captura_de_pantalla_2026-07-07_012157.png',
    caption: 'Glaseados y baños de chocolate paso a paso'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/r3hFBBqj7JSZ3K4WuyT5pK/Captura_de_pantalla_2026-07-07_012244.png',
    caption: 'El mercado de las minidonas saladas'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1bnyaUS8s5D6h1UukHVbiA/Captura_de_pantalla_2026-07-07_012333.png',
    caption: 'Secretos de la fritura perfecta'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/rXqDKMabcFvwgo5RtiqoHz/Captura_de_pantalla_2026-07-07_012426.png',
    caption: 'Foto & branding: composiciones que venden'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7eVHjC5F2HvWQpTZGGuA1r/Captura_de_pantalla_2026-07-07_012446.png',
    caption: 'Tu negocio en dólares: precios, ventas y escala'
  }];
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const total = pages.length;
  const paginate = (dir: number) => {
    setDirection(dir);
    setIndex(prev => (prev + dir + total) % total);
  };
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  const variants = {
    enter: (dir: number) => ({
      opacity: 0,
      x: dir > 0 ? 60 : -60
    }),
    center: {
      opacity: 1,
      x: 0
    },
    exit: (dir: number) => ({
      opacity: 0,
      x: dir > 0 ? -60 : 60
    })
  };
  return <section className="py-20 px-4 bg-[#FFFDF9]" data-id="element-93" data-mp="38xuxovtgketc">
      <div className="max-w-4xl mx-auto" data-id="element-94" data-mp="38y4qss9sv239">
        <div className="text-center mb-12" data-id="element-95" data-mp="3helte7iqbb89">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-pink-200 bg-pink-50 text-[#E85D75] text-sm font-bold tracking-wide mb-6 uppercase shadow-sm" data-id="element-96" data-mp="3hdu8bqmrcvw8">
            <span className="w-2 h-2 rounded-full bg-[#E85D75]" data-id="element-97" data-mp="3q7ywu3ef5v8l"></span>
            MIRÁ POR DENTRO
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-4 text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-98" data-mp="3v5ikftx0bkd7">
            ASÍ ES EL MATERIAL POR DENTRO
          </h2>
          <p className="text-xl text-[#5C3D3A] font-medium max-w-2xl mx-auto" data-id="element-99" data-mp="32gthdpce54yt">
            Un vistazo real a las páginas del sistema: recetas, técnicas y guías
            explicadas paso a paso.
          </p>
        </div>

        <div className="relative max-w-sm mx-auto" data-id="element-100" data-mp="3cgke7xofbw22">
          <div className="relative overflow-hidden rounded-3xl border border-amber-100 shadow-2xl bg-white aspect-[210/297]" data-id="element-101" data-mp="mq79x3f541h9">
            <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-102" data-mp="roiizbxm27yf">
              <motion.img key={index} src={pages[index].src} alt={pages[index].caption} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-103" data-mp="20wbn3fbm1lh" />
            </AnimatePresence>

            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-6 pt-16" data-id="element-104" data-mp="70se2y8ddkyx">
              <p className="text-white font-bold text-lg font-['Outfit',sans-serif]" data-id="element-105" data-mp="3fdyb3l2mjl4u">
                Página {index + 1} de {total}
                <span className="block text-pink-200 font-medium text-base" data-id="element-106" data-mp="3p5lynaw28i11">
                  {pages[index].caption}
                </span>
              </p>
            </div>

            <button type="button" onClick={() => paginate(-1)} aria-label="Página anterior" className="absolute left-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/90 text-[#2D1816] flex items-center justify-center shadow-lg hover:bg-white hover:scale-105 transition-all focus:outline-none focus:ring-2 focus:ring-[#E85D75]" data-id="element-107" data-mp="3kdautwy78c37">
              <ChevronLeft className="w-6 h-6" data-id="element-108" data-mp="1bzfi0bd68w1i" />
            </button>
            <button type="button" onClick={() => paginate(1)} aria-label="Página siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/90 text-[#2D1816] flex items-center justify-center shadow-lg hover:bg-white hover:scale-105 transition-all focus:outline-none focus:ring-2 focus:ring-[#E85D75]" data-id="element-109" data-mp="xa9o92x3ry10">
              <ChevronRight className="w-6 h-6" data-id="element-110" data-mp="1uwywvvmb98vu" />
            </button>
          </div>

          <div className="flex justify-center items-center gap-2.5 mt-6" data-id="element-111" data-mp="1gz0jotjq7ihx">
            {pages.map((_, i) => <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Ir a la página ${i + 1}`} className={`h-2.5 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-[#E85D75] ${i === index ? 'w-8 bg-[#E85D75]' : 'w-2.5 bg-pink-200 hover:bg-pink-300'}`} data-id="element-112" data-mp="1kzawoq5xr96a" data-mpi={i} />)}
          </div>
        </div>
      </div>
    </section>;
}
function ChangesSection() {
  const changes = [{
    emoji: '⚡',
    title: 'Cero confusión, cero improvisación',
    desc: 'Abrís el tomo, seguís el paso a paso y el resultado sale. Sin buscar más, sin improvisar más.'
  }, {
    emoji: '👑',
    title: 'Autoridad y confianza',
    desc: 'Con un sistema probado en la mano, llegás a cada pedido sabiendo exactamente lo que hacés y cómo lo presentás.'
  }, {
    emoji: '📈',
    title: 'Un negocio que crece en serio',
    desc: 'Los 6 tomos te dan las herramientas para pasar de hacer minidonas para amigos a tener clientes fijos y pedidos recurrentes.'
  }, {
    emoji: '😌',
    title: 'Se acabó el pánico antes de cada pedido',
    desc: 'Dejás de improvisar decoraciones y precios. Tenés un sistema que trabaja por vos cada vez que abrís el pack.'
  }, {
    emoji: '💰',
    title: 'Ingresos reales desde casa',
    desc: 'El Tomo 6 te enseña exactamente cómo calcular tus precios, manejar tus costos y empezar a cobrar lo que realmente vale tu trabajo.'
  }];
  return <section className="py-20 px-4 bg-[#FFFDF9]" data-id="element-113" data-mp="1ux9z4kl63u1b">
      <div className="max-w-4xl mx-auto" data-id="element-114" data-mp="1z1q0c8ju6da7">
        <div className="text-center mb-16" data-id="element-115" data-mp="1yybz53mwsa4c">
          <h2 className="text-3xl md:text-5xl font-black mb-4 text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-116" data-mp="23zjb7ew33vgt">
            ¿QUÉ VA A CAMBIAR EN TU VIDA?
          </h2>
          <p className="text-xl text-[#E85D75] font-bold font-['Outfit',sans-serif]" data-id="element-117" data-mp="2dpkxq28sh5tm">
            Resultados reales desde la primera semana.
          </p>
        </div>

        <div className="space-y-4" data-id="element-118" data-mp="2imuj96t24xc6">
          {changes.map((change, idx) => <div key={idx} className="flex items-start gap-4 p-6 bg-white rounded-xl border border-amber-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-119" data-mp="2mrc1h1jrr2ku" data-mpi={idx}>
              <div className="bg-pink-50 w-12 h-12 rounded-lg flex items-center justify-center text-2xl flex-shrink-0" data-id="element-120" data-mp="2rmzq9fuc9tpt">
                <span role="img" aria-label={change.title} data-id="element-121" data-mp="xb2y1ko2ojtp">
                  {change.emoji}
                </span>
              </div>
              <div data-id="element-122" data-mp="20n1krpetda7p">
                <h3 className="text-xl font-bold text-[#2D1816] mb-2 font-['Outfit',sans-serif]" data-id="element-123" data-mp="20mibsy755w5t">
                  {change.title}
                </h3>
                <p className="text-[#5C3D3A]" data-id="element-124" data-mp="29n6qzw89u2ka">{change.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function OfferSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 27,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-24 px-4 relative bg-[#FFF5EB]" id="oferta" data-id="element-125" data-mp="3gy16y8mjnikp">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFF5EB] via-pink-50/50 to-[#FFF5EB]" data-id="element-126" data-mp="3lx44l8072min"></div>
      <div className="max-w-2xl mx-auto relative z-10" data-id="element-127" data-mp="370dbfgh4671h">
        {/* Título por fuera de las tarjetas */}
        <div className="text-center mb-8" data-id="element-128" data-mp="3byomfuj5anla">
          <div className="inline-block bg-[#E85D75] text-white font-bold px-4 py-1.5 rounded-full text-xs mb-4 animate-pulse font-['Outfit',sans-serif] tracking-widest uppercase" data-id="element-129" data-mp="3bxd8j1vzjzgg">
            🔥 Oferta de lanzamiento
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#2D1816] font-['Outfit',sans-serif] leading-tight" data-id="element-130" data-mp="2o9ncg2unz4dw">
            ELEGÍ TU PLAN PARA EMPEZAR HOY
          </h2>
        </div>

        {/* Cuenta regresiva compartida */}
        <div className="bg-white border border-[#E85D75]/30 rounded-2xl p-5 mb-10 shadow-sm" data-id="element-131" data-mp="2f8p5bboxigr3">
          <p className="text-[#E85D75] font-bold mb-4 flex items-center justify-center gap-2 text-sm font-['Outfit',sans-serif] text-center" data-id="element-132" data-mp="2jash61fifncw">
            <Clock className="w-4 h-4" data-id="element-133" data-mp="2zpa1v65odofc" /> ¡Última oportunidad! El precio sube
            cuando termine la cuenta regresiva.
          </p>
          <div className="flex items-stretch justify-center gap-3" data-id="element-134" data-mp="2prly5qq3d6l1">
            {[{
            value: timeLeft.hours,
            label: 'Horas'
          }, {
            value: timeLeft.minutes,
            label: 'Minutos'
          }, {
            value: timeLeft.seconds,
            label: 'Segundos'
          }].map((unit, i) => <div key={i} className="flex-1 max-w-[100px] bg-[#4A2B29] rounded-xl border border-white/10 py-3" data-id="element-135" data-mp="2bzfqyu4x29xq" data-mpi={i}>
                <div className="text-3xl md:text-4xl font-black text-white font-['Outfit',sans-serif] tabular-nums" data-id="element-136" data-mp="2725rsmrq6jwp">
                  {String(unit.value).padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-xs text-pink-200/70 font-semibold tracking-widest uppercase mt-1" data-id="element-137" data-mp="1x1wvl8xqgyhb">
                  {unit.label}
                </div>
              </div>)}
          </div>
        </div>

        {/* ===== COMBO BUSINESS PRO — EL MÁS ELEGIDO ===== */}
        <div className="relative mb-10 pt-5" data-id="element-138" data-mp="ck4ggz556qy3">
          {/* Cinta "EL MÁS ELEGIDO" */}
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 z-20" data-id="element-139" data-mp="hjqqz0tl5t37">
            <div className="flex items-center gap-2 bg-amber-400 text-[#2D1816] font-black px-5 py-2 rounded-full text-sm md:text-base font-['Outfit',sans-serif] tracking-wider uppercase shadow-[0_8px_25px_rgba(245,158,11,0.5)] animate-pulse whitespace-nowrap" data-id="element-140" data-mp="mjbqpdgky5gz">
              <Star className="w-5 h-5 fill-current" data-id="element-141" data-mp="3q0buw37d1vzg" />
              El más elegido
              <Star className="w-5 h-5 fill-current" data-id="element-142" data-mp="3uydecp8p7xbg" />
            </div>
          </div>

          {/* Halo dorado detrás de la tarjeta del combo */}
          <div className="absolute -inset-2 bg-amber-400/25 rounded-[2rem] blur-2xl" data-id="element-143" data-mp="32ahi1ln1k7f7"></div>

          <div className="relative bg-gradient-to-b from-[#4A2B29] to-[#3E201D] rounded-3xl border-2 border-amber-400/70 ring-2 ring-amber-400/20 p-6 md:p-10 pt-10 text-center shadow-[0_35px_80px_-20px_rgba(0,0,0,0.6)]" data-id="element-144" data-mp="328n62wtqzpn9">
            <h3 className="text-2xl md:text-3xl font-black text-white mb-4 font-['Outfit',sans-serif] leading-tight" data-id="element-145" data-mp="2lz9v6w2c12is">
              COMBO BUSINESS PRO: TODO EN UNO 👑
            </h3>

            <img src="https://cdn.magicpatterns.com/uploads/6qYWhJGbenC1ycbU4ZGJ9M/ChatGPT_Image_9_jul_2026,_08_39_25_p.m..png" alt="Combo Business Pro con Mega Pack Emprende Minidonas 360 y Equilibrium Pro" className="w-full max-w-md mx-auto h-auto rounded-2xl border border-amber-300/30 shadow-xl mb-7" data-id="element-146" data-mp="2c0kakvj1x3yu" />

            <p className="text-pink-50/90 leading-relaxed text-base md:text-lg mb-6" data-id="element-147" data-mp="1ob9jy6vf0pyf">
              ¿Por qué limitarte si podés tenerlo todo? Llevate el{' '}
              <strong className="text-white" data-id="element-148" data-mp="1tacciru7l3pi">Mega Pack 360</strong> más el
              sistema{' '}
              <strong className="text-amber-300" data-id="element-149" data-mp="1fb36gkzpvpz9">Equilibrium Pro</strong>. Con
              este combo blindás tu negocio: tenés las recetas clásicas que
              todos aman y las opciones{' '}
              <strong className="text-amber-300" data-id="element-150" data-mp="10nupt4nn2sfw">
                Sin TACC, Keto, Fit y Sin Azúcar
              </strong>{' '}
              que nadie más ofrece en tu ciudad. ¡Domina el 100% del mercado y
              asegurate de que ningún cliente se vaya con la competencia!
            </p>

            {/* Qué incluye */}
            <ul className="text-left max-w-md mx-auto space-y-2.5 mb-8" data-id="element-151" data-mp="1jmgtmrajixni">
              {['Mega Pack Emprende Minidonas 360 completo (6 tomos + 3 bonos)', 'Sistema Minidonas Equilibrium Pro', 'Recetas Sin TACC, Keto, Fit y Sin Azúcar', 'Dominás el 100% del mercado de tu ciudad'].map((item, i) => <li key={i} className="flex items-start gap-3 text-pink-50 font-medium" data-id="element-152" data-mp="1te32igzeokn3" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-153" data-mp="1of9yrg9x8804" />
                  {item}
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-154" data-mp="1xemznkjzbo98">
              <p className="text-pink-200/70 text-lg line-through mb-1 font-medium" data-id="element-155" data-mp="1xfonkpm3g58d">
                Precio regular: $69.990
              </p>
              <p className="text-amber-400 font-black tracking-widest text-sm mb-1 font-['Outfit',sans-serif] uppercase" data-id="element-156" data-mp="zzaea5jlynjc">
                Solo hoy:
              </p>
              <p className="text-5xl md:text-7xl font-black text-white mb-2 font-['Outfit',sans-serif]" data-id="element-157" data-mp="13z11y0du8njn">
                <span className="text-amber-300 text-[40px] font-[700]" data-id="element-158" data-mp="18totk8451y2g">$</span>
                20.990
              </p>
              <p className="text-pink-100/70 font-medium text-sm" data-id="element-159" data-mp="1iprujan97qnt">
                Pago seguro en pesos argentinos.
              </p>
            </div>

            <CTAButton text="👑 SÍ, QUIERO EL COMBO COMPLETO ($20.990)" subtext="Pago con tarjeta de crédito o débito" variant="combo" href={COMBO_CHECKOUT_URL} contentName="Combo Business Pro — Minidonas 360 + Equilibrium Pro" value={20990} data-id="element-160" data-mp="1npmjh8ngy668" />

            <div className="mt-6 flex flex-col items-center gap-2 text-sm text-pink-100/80 font-medium" data-id="element-161" data-mp="3thtcar2vpsv6">
              <div className="flex items-center gap-1 text-amber-400" data-id="element-162" data-mp="3lyadpch5jr1h">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-163" data-mp="3h83lz3rcfqf0" data-mpi={i} />)}
              </div>
              <p data-id="element-164" data-mp="3c8qto3hpdr51">4.9/5 — Reseñas verificadas</p>
              <p className="flex items-center gap-1" data-id="element-165" data-mp="3c9k3xefveyrx">
                <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-166" data-mp="387faafpfa25a" /> Garantía de
                devolución de 7 días: riesgo cero.
              </p>
            </div>
          </div>
        </div>

        {/* Separador */}
        <div className="flex items-center gap-4 mb-8" data-id="element-167" data-mp="3sp98m988kox">
          <div className="flex-1 h-px bg-amber-200" data-id="element-168" data-mp="3quksxyqyag3"></div>
          <span className="text-[#5C3D3A] font-bold text-sm uppercase tracking-widest font-['Outfit',sans-serif]" data-id="element-169" data-mp="3vvotraz5ydt9">
            o llevá solo el pack
          </span>
          <div className="flex-1 h-px bg-amber-200" data-id="element-170" data-mp="2khb88crvuage"></div>
        </div>

        {/* ===== OPCIÓN INDIVIDUAL — MEGA PACK 360 ===== */}
        <div className="relative" data-id="element-171" data-mp="2fhgem1gq36rn">
          <div className="absolute -inset-2 bg-[#E85D75]/10 rounded-[2rem] blur-2xl" data-id="element-172" data-mp="2fkku3uzn1oxm"></div>

          <div className="relative bg-gradient-to-b from-[#4A2B29] to-[#3E201D] rounded-3xl border border-pink-400/30 ring-1 ring-white/10 p-6 md:p-10 text-center shadow-[0_30px_70px_-20px_rgba(0,0,0,0.5)]" data-id="element-173" data-mp="78h15tdscwpw">
            <div className="inline-block bg-amber-400 text-[#2D1816] font-black px-4 py-1.5 rounded-full text-sm mb-6 font-['Outfit',sans-serif]" data-id="element-174" data-mp="3ucesyr4ubhfp">
70% de descuento
            </div>

            <h3 className="text-xl md:text-2xl font-black text-white mb-6 font-['Outfit',sans-serif]" data-id="element-175" data-mp="q12rxz9u5x3m">
              MEGA PACK 360 — 6 TOMOS + 3 BONOS
            </h3>

            <div className="relative w-full max-w-md mx-auto mb-7" data-id="element-176" data-mp="gyjrfltivwkj">
              <img src="https://cdn.magicpatterns.com/uploads/7BWHgWK9Xb1uuBT1NMp52c/ChatGPT_Image_7_jul_2026,_06_39_02_p.m..png" alt="Los 6 tomos del Mega Pack Emprende Minidonas 360, un sistema completo" className="w-full h-auto block" data-id="element-177" data-mp="lyfw7na1ns15" />
            </div>

            <div className="mb-8" data-id="element-178" data-mp="36q89n8pyufa6">
              <p className="text-pink-200/70 text-lg line-through mb-1 font-medium" data-id="element-179" data-mp="2y7whu2yqfrva">
                Precio regular: $49.990
              </p>
              <p className="text-[#E85D75] font-black tracking-widest text-sm mb-1 font-['Outfit',sans-serif] uppercase" data-id="element-180" data-mp="2u5jdnizmw20m">
                Solo hoy:
              </p>
              <p className="text-5xl md:text-7xl font-black text-white mb-2 font-['Outfit',sans-serif]" data-id="element-181" data-mp="33797swkwhf23">
                <span className="text-pink-300 text-[40px] font-[700]" data-id="element-182" data-mp="2fgvnjs8k4ki2">$</span>
                14.990
              </p>
              <p className="text-pink-100/70 font-medium text-sm" data-id="element-183" data-mp="2ajd9jnfonf37">
                Pago seguro en pesos argentinos.
              </p>
            </div>

            <CTAButton text="✅ SÍ, QUIERO EL PACK COMPLETO ($14.990)" subtext="Pago con tarjeta de crédito o débito" data-id="element-184" data-mp="2p919olc4o7pc" />

            <div className="mt-8 flex flex-col items-center gap-2 text-sm text-pink-100/80 font-medium" data-id="element-185" data-mp="1wqnl7ccoly2x">
              <div className="flex items-center gap-1 text-amber-400" data-id="element-186" data-mp="1rscevblli5pg">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-187" data-mp="3rullqqd8hs46" data-mpi={i} />)}
              </div>
              <p data-id="element-188" data-mp="nizmdc96c0t">4.9/5 — Reseñas verificadas</p>
              <p className="flex items-center gap-1" data-id="element-189" data-mp="m7vudit549p">
                <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-190" data-mp="5dzapqslplk0" /> Garantía de
                devolución de 7 días: riesgo cero.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function GuaranteeSection() {
  return <section className="py-20 px-4 bg-[#FFFDF9]" data-id="element-191" data-mp="38x2b5ib4o1fn">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-10 bg-[#FFF5EB] p-8 md:p-12 rounded-3xl border border-amber-200 shadow-sm" data-id="element-192" data-mp="3dtsse8yo532n">
        <div className="flex-shrink-0" data-id="element-193" data-mp="3hy0k8f0faz53">
          <div className="w-32 h-32 bg-gradient-to-br from-amber-300 to-amber-500 rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(245,158,11,0.3)]" data-id="element-194" data-mp="3mvikzi4ae820">
            <ShieldCheck className="w-16 h-16 text-white" data-id="element-195" data-mp="124rsqtz3hnof" />
          </div>
        </div>
        <div data-id="element-196" data-mp="126updwur6f24">
          <h2 className="text-3xl font-black text-[#2D1816] mb-2 font-['Outfit',sans-serif]" data-id="element-197" data-mp="1c8oyutx2vmpa">
            TU INVERSIÓN ESTÁ 100% PROTEGIDA
          </h2>
          <h3 className="text-xl font-bold text-[#E85D75] mb-6 font-['Outfit',sans-serif]" data-id="element-198" data-mp="17a5daumeccxg">
            GARANTÍA TOTAL DE 7 DÍAS
          </h3>
          <div className="space-y-4 text-[#5C3D3A] font-medium" data-id="element-199" data-mp="yha3ropwbv1v">
            <p data-id="element-200" data-mp="yh1s205ievs9">Tu dinero está completamente protegido.</p>
            <p data-id="element-201" data-mp="tih2qvrspwil">
              Tenés 7 días completos para explorar los 6 tomos, probar las
              recetas, usar los bonos y evaluar el sistema completo.
            </p>
            <p data-id="element-202" data-mp="jk16yfhtpz2r">
              Si por cualquier motivo no quedás 100% satisfecha, simplemente
              escribinos a atencionrecursohub@gmail.com y te devolvemos el 100%
              de tu compra.
            </p>
            <p className="font-bold text-[#2D1816]" data-id="element-203" data-mp="2dykc6ptr2goh">
              Cero riesgo para vos. Compromiso total de nuestra parte.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialsSection() {
  return <section className="py-20 px-4 bg-[#FFF5EB]" data-id="element-204" data-mp="2t5qljk9ef9j8">
      <div className="max-w-5xl mx-auto" data-id="element-205" data-mp="2x6ka8fuo0sd6">
        <h2 className="text-3xl md:text-5xl font-black mb-16 text-center text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-206" data-mp="2x5inhe4aehfm">
          LO QUE DICEN OTRAS EMPRENDEDORAS
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-207" data-mp="2odp1hc5zoein">
          <div className="bg-white p-8 rounded-2xl border border-amber-100 shadow-sm relative" data-id="element-208" data-mp="2ocdvr6szgwow">
            <div className="flex items-center gap-1 text-amber-400 mb-4" data-id="element-209" data-mp="29jc45vpexfa3">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-210" data-mp="2ee8036xrsmsh" data-mpi={i} />)}
            </div>
            <p className="text-[#5C3D3A] text-lg italic mb-6 leading-relaxed" data-id="element-211" data-mp="20idxt6ri4voc">
              "Mi mayor problema era no saber por dónde empezar. El Mega Pack me
              dio un sistema claro, paso a paso. En menos de dos semanas ya
              tenía mis primeros pedidos confirmados."
            </p>
            <div className="flex items-center gap-4" data-id="element-212" data-mp="3nhry6y9umk5">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center text-xl font-bold text-[#E85D75] font-['Outfit',sans-serif]" data-id="element-213" data-mp="dres7q9kprd3">
                M
              </div>
              <div data-id="element-214" data-mp="mkrpt5il1h5i">
                <p className="font-bold text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-215" data-mp="mlb9orrsmfm6">
                  María G.
                </p>
                <p className="text-sm text-[#5C3D3A]" data-id="element-216" data-mp="hroy72xd8hry">
                  Emprendedora desde casa, Buenos Aires
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-amber-100 shadow-sm relative" data-id="element-217" data-mp="rjctjex1miyp">
            <div className="flex items-center gap-1 text-amber-400 mb-4" data-id="element-218" data-mp="15ikv2egoi362">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-219" data-mp="11ik3ds4kjvh2" data-mpi={i} />)}
            </div>
            <p className="text-[#5C3D3A] text-lg italic mb-6 leading-relaxed" data-id="element-220" data-mp="37bijzz7c4blq">
              "Las minidonas saladas del Tomo 3 me abrieron un mercado que no
              sabía que existía. Ahora hago catering de brunchs y cobro el
              triple de lo que cobraba antes."
            </p>
            <div className="flex items-center gap-4" data-id="element-221" data-mp="1dkesefkdrkpt">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center text-xl font-bold text-[#E85D75] font-['Outfit',sans-serif]" data-id="element-222" data-mp="1rimludi7k3w8">
                V
              </div>
              <div data-id="element-223" data-mp="21h2am9trj12k">
                <p className="font-bold text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-224" data-mp="21gahr6rjvhfz">
                  Valentina R.
                </p>
                <p className="text-sm text-[#5C3D3A]" data-id="element-225" data-mp="1whfyy4tl1svv">Pastelera, Bogotá</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function FAQSection() {
  const faqs = [{
    q: '¿ES UN PRODUCTO FÍSICO O DIGITAL?',
    a: 'El Mega Pack Emprende Minidonas 360 es un producto 100% digital que se entrega de forma instantánea en formato PDF. Podés acceder desde tu celular, tablet o computadora en cualquier momento.'
  }, {
    q: '¿NECESITO EXPERIENCIA PREVIA EN PASTELERÍA?',
    a: 'No. El sistema está diseñado desde cero para que cualquier persona pueda seguirlo sin experiencia previa. Cada tomo va paso a paso con explicaciones claras y técnicas accesibles.'
  }, {
    q: '¿FUNCIONA PARA TODOS LOS PAÍSES DE LATINOAMÉRICA?',
    a: 'Sí. El sistema usa nombres neutros para los ingredientes y una guía de equivalencias para Argentina, México, Colombia, Chile, Perú y toda Latinoamérica.'
  }, {
    q: '¿LOS BONOS ESTÁN INCLUIDOS?',
    a: 'Sí. Los 3 bonos están incluidos de forma completamente gratuita con tu compra de hoy. No hay costos adicionales ni sorpresas.'
  }, {
    q: '¿PUEDO IMPRIMIR LOS MATERIALES?',
    a: 'Sí. Todos los tomos y bonos están en formato PDF de alta calidad, listos para imprimir o usar en pantalla según prefieras.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-[#FFFDF9]" data-id="element-226" data-mp="2249htmbifiuu">
      <div className="max-w-3xl mx-auto" data-id="element-227" data-mp="2262pn4xv094f">
        <h2 className="text-3xl md:text-5xl font-black mb-12 text-center text-[#2D1816] font-['Outfit',sans-serif]" data-id="element-228" data-mp="7ob69afvsxe5">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-229" data-mp="2uyjl5urj0o1">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl border border-amber-100 overflow-hidden shadow-sm hover:border-pink-200 transition-colors" data-id="element-230" data-mp="3u45loz6x3681" data-mpi={idx}>
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-231" data-mp="qmnd2pjblv6k">
                <span className="font-bold text-[#2D1816] pr-4 font-['Outfit',sans-serif]" data-id="element-232" data-mp="loc1oaddncm8">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-[#E85D75] flex-shrink-0" data-id="element-233" data-mp="cnnspu2uc2g7" /> : <ChevronDown className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-234" data-mp="32c6h5ofpmv3s" />}
              </button>
              {openIdx === idx && <div className="px-6 pb-5 text-[#5C3D3A] leading-relaxed font-medium" data-id="element-235" data-mp="2xck4ph7phiw1">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}
function FinalCloseSection() {
  return <section className="py-24 px-4 relative overflow-hidden bg-[#4A2B29]" data-id="element-236" data-mp="1huxdqdm6efq5">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-[#3E201D] via-[#4A2B29] to-[#4A2B29]" data-id="element-237" data-mp="1lvh7d77jj17j"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-238" data-mp="1qok4tqffuut0">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-8 font-['Outfit',sans-serif]" data-id="element-239" data-mp="1vkr0mqe4epx8">
          ÚLTIMA OPORTUNIDAD
        </h2>

        <div className="text-xl text-pink-50/90 space-y-6 mb-12 max-w-2xl mx-auto font-medium" data-id="element-240" data-mp="25jqc0gq9sznx">
          <p data-id="element-241" data-mp="25hvlmmw8cfcg">Tu negocio de minidonas merece la mejor versión tuya.</p>
          <p data-id="element-242" data-mp="29kilnb3216kq">
            No la versión que improvisa recetas buscando en internet a las 11 de
            la noche.
          </p>
          <p data-id="element-243" data-mp="f7amx8bykatt">
            Dejá de buscar recetas sueltas que no funcionan. Dejá de improvisar
            precios y presentaciones.
          </p>
          <p className="font-bold text-white" data-id="element-244" data-mp="3g1gmzet474rk">
            Tomá el control de tu emprendimiento con un sistema completo
            diseñado para que empieces a vender desde el primer día.
          </p>
        </div>
      </div>
    </section>;
}
function Footer() {
  return <footer className="bg-[#2D1816] py-12 px-4 border-t border-[#3E201D]" data-id="element-245" data-mp="3l1ur4lrlhukb">
      <div className="max-w-5xl mx-auto text-center text-[#A88B88] text-sm space-y-6 font-medium" data-id="element-246" data-mp="3kzs1i2ucu3g4">
        <p data-id="element-247" data-mp="2x9nurmlvdnkw">
          © 2025 RecursoHub — Todos los derechos reservados.
          <br data-id="element-248" data-mp="2seqqeszjc2ec" />
          www.recursohub.com | atencionrecursohub@gmail.com
        </p>

        <p className="max-w-3xl mx-auto text-xs leading-relaxed opacity-80" data-id="element-249" data-mp="373eigpa69tzj">
          El Mega Pack Emprende Minidonas 360 es un recurso educativo digital
          diseñado para emprendedoras que desean iniciar o profesionalizar su
          negocio de minidonas. Los resultados individuales pueden variar según
          el esfuerzo, dedicación y contexto de cada persona.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-xs" data-id="element-250" data-mp="p3c8x1pvnbbp">
          <a href="#" className="hover:text-pink-300 transition-colors" data-id="element-251" data-mp="tvnasa46h76w">
            Términos y Condiciones
          </a>
          <span className="opacity-50" data-id="element-252" data-mp="g4qiyli2su0w">|</span>
          <a href="#" className="hover:text-pink-300 transition-colors" data-id="element-253" data-mp="g1vzaw6vzd8j">
            Política de Privacidad
          </a>
          <span className="opacity-50" data-id="element-254" data-mp="17v4tq8uslq8c">|</span>
          <a href="#" className="hover:text-pink-300 transition-colors" data-id="element-255" data-mp="17vela0vhk5g5">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}